export const Logo = () => {
    return (
        <header>
            <a
                className="c-map__header t-hidden-mobile"
                role="link"
                href={'/'}
                title={'Til forsiden'}
                id={'map_main_title'}
                aria-label={'Vegkart'}
                tabIndex={0}
            >
                <div className="c-map__header-link">Til forsiden</div>
                <h1 className="c-map__header-text">NVDB Vegkart</h1>
            </a>
        </header>
    );
};
